import { useState, useCallback } from "react";

export const useChatAttachments = () => {
  const [attachments, setAttachments] = useState([]);

  const uploadFile = useCallback(async (file) => {
    // TODO: integrar con API real de subida cuando exista
    await new Promise((resolve) => setTimeout(resolve, 800));
    if (file.type?.startsWith?.("image/")) {
      return URL.createObjectURL(file);
    }
    return `/uploads/${file.name ?? "document"}`;
  }, []);

  const handleFilesSelected = useCallback((files) => {
    if (!files || files.length === 0) return;
    const newAttachments = Array.from(files).map((file, i) => {
      const id = `${Date.now()}-${i}`;
      const isImage = file.type?.startsWith?.("image/") ?? false;
      return isImage
        ? { id, type: "image", imageUrl: URL.createObjectURL(file), isLoading: true }
        : {
            id,
            type: "file",
            name: file.name ?? "document",
            fileType: file.name?.includes?.(".")
              ? file.name.split(".").pop()
              : file.type ?? "",
            isLoading: true,
          };
    });
    setAttachments((prev) => [...prev, ...newAttachments]);
    Array.from(files).forEach((file, i) => {
      const att = newAttachments[i];
      if (!att) return;
      uploadFile(file)
        .then((serverUrl) => {
          setAttachments((prev) =>
            prev.map((a) =>
              a.id === att.id ? { ...a, isLoading: false, imageUrl: serverUrl ?? a.imageUrl } : a
            )
          );
        })
        .catch(() => {
          setAttachments((prev) =>
            prev.map((a) => (a.id === att.id ? { ...a, isLoading: false } : a))
          );
        });
    });
  }, [uploadFile]);

  const handleAttachmentRemove = useCallback((id) => {
    setAttachments((prev) => {
      const removed = prev.find((a) => a.id === id);
      if (removed?.type === "image" && removed?.imageUrl?.startsWith?.("blob:")) {
        URL.revokeObjectURL(removed.imageUrl);
      }
      return prev.filter((a) => a.id !== id);
    });
  }, []);

  const handleAddMenuChange = useCallback((value, itemData) => {
    if (value !== "upload") {
      console.log("Seleccionaste:", itemData?.label ?? value, value);
    }
  }, []);

  const handleModeMenuChange = useCallback((modeValue, selectedValue, itemData) => {
    console.log("Modo:", modeValue, "Selección:", selectedValue, itemData);
  }, []);

  return {
    attachments,
    handleFilesSelected,
    handleAttachmentRemove,
    handleAddMenuChange,
    handleModeMenuChange,
  };
};
